import { render } from "./DuelsGamesElement.vue?vue&type=template&id=fda60be2&scoped=true"
import script from "./DuelsGamesElement.vue?vue&type=script&lang=js"
export * from "./DuelsGamesElement.vue?vue&type=script&lang=js"

import "./DuelsGamesElement.vue?vue&type=style&index=0&id=fda60be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda60be2"]])

export default __exports__